export default {
  "content": "<g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14 8A6 6 0 112 8a6 6 0 0112 0zm-6 8A8 8 0 108 0a8 8 0 000 16zm-1-5a1 1 0 102 0V8a1 1 0 10-2 0v3zm1-7a1 1 0 100 2 1 1 0 000-2z\" fill=\"#ff00cb\"/></g><defs><clipPath id=\"clip0\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};